import { makeStyles } from '@mui/styles';

const useChipStyles = makeStyles({
	root: {
		backgroundColor: 'white',
		border: '1px solid #79747E',
		borderRadius: 8,
		color: '#000000DE',
		fontFamily: 'Montserrat',
		fontSize: 12,
		padding: '6px 12px',
		position: 'relative',
		'&:hover': {
			backgroundColor: '#FFFBFE00',
		},
	},
});

export default useChipStyles;
